import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const FooterLinksContainer = styled.div`
  display: flex;
  justify-content: space-between;
  column-gap: 2rem;
  justify-self: start;
  align-self: start;

  @media screen and (max-width: ${layout.md}) {
    display: none;
  }
`;

export const FooterLinksMobileContainer = styled(FooterLinksContainer)`
  display: none;

  @media screen and (max-width: ${layout.md}) {
    display: flex;
  }
`;

export const LinksColumn = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1.6rem;

  @media screen and (max-width: ${layout.md}) {
    row-gap: 2rem;
  }
`;

export const LinkList = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 0.75rem;

  .footer-link > p {
    color: ${palette.white};
    text-decoration: none;

    @media screen and (max-width: ${layout.md}) {
      font-size: 0.875rem;
    }
  }
`;
